<template>
  <div class="prices mt-4">
    <div class="row">
      <div class="col-12 mb-4 ">
        <div
          class="text-center"
        >
          <div
            class="d-inline"
            style="position: relative;"
          >
            <button
              :class="{ 'bg-primary text-white': !yearly }"
              class="btn btn-outline-primary py-2 px-4 px-md-5 price-button"
              style="border-radius: 25px 0 0 25px;"
              @click="yearly = !yearly"
            >
              Monatlich
            </button>
            <button
              :class="{ 'bg-primary text-white': yearly }"
              class="btn btn btn-outline-primary py-2 px-4 px-md-5 price-button"
              style="border-radius: 0 25px 25px 0; margin-left: -5px;"
              @click="yearly = !yearly"
            >
              Jährlich
            </button>
            <span
              class="badge small badge-pill badge-outline-success"
              style="position:absolute; top: -18px; right: -25px; font-size: 0.75rem;"
            >10&nbsp;% sparen</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-4">
        <wave-card>
          <template #head>
            <h6 class="text-white mb-2">
              Privat
            </h6>
            <h5 class="mb-0">
              Kostenlos
            </h5>
          </template>
          <template #body>
            <feature-private></feature-private>
            <slot name="privat"></slot>
            <div class="text-center small text-muted mt-4 mb-4">
              Nur für Privatpersonen, gemeinnützige Vereine und Kleinunternehmer gem. § 19 UStG.
            </div>
          </template>
        </wave-card>
      </div>

      <div class="col-md-4">
        <wave-card>
          <template #head>
            <h6 class="text-white mb-2">
              Business
            </h6>
            <h5
              v-if="!yearly"
              class="mb-0"
            >
              9,90 € <small>/ Monat</small>
            </h5>
            <h5
              v-else
              class="mb-0"
            >
              106,92 € <small>/ Jahr</small>
            </h5>
          </template>
          <template #body>
            <feature-business :yearly="yearly"></feature-business>
            <slot name="business"></slot>
            <div class="text-center small text-muted mt-4 mb-4">
              Nur für Geschäftskunden.
            </div>
            <div class="text-center small text-muted mt-4 mb-4">
              Der Preis versteht sich zzgl. der gesetzlichen MwSt. von 19%.
            </div>
          </template>
        </wave-card>
      </div>

      <div class="col-md-4">
        <wave-card>
          <template #head>
            <h6 class="text-white mb-2">
              Premium
            </h6>
            <h5
              v-if="!yearly"
              class="mb-0"
            >
              19,90 € <small>/ Monat</small>
            </h5>
            <h5
              v-else
              class="mb-0"
            >
              214,92 € <small>/ Jahr</small>
            </h5>
          </template>
          <template #body>
            <feature-premium :yearly="yearly"></feature-premium>
            <slot name="premium"></slot>
            <div class="text-center small text-muted mt-4 mb-4">
              Nur für Geschäftskunden.
            </div>
            <div class="text-center small text-muted mt-4 mb-4">
              Der Preis versteht sich zzgl. der gesetzlichen MwSt. von 19%.
            </div>
          </template>
        </wave-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      yearly: false,
    }
  }

}
</script>
